<div class="dashboard">
  <h2>Engagement Frequency Analysis</h2>

  <div class="filters">
    <mat-form-field appearance="outline">
      <mat-label>Start Date</mat-label>
      <input matInput [matDatepicker]="sp" [(ngModel)]="startDate">
      <mat-datepicker-toggle matSuffix [for]="sp"></mat-datepicker-toggle>
      <mat-datepicker #sp></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>End Date</mat-label>
      <input matInput [matDatepicker]="ep" [(ngModel)]="endDate">
      <mat-datepicker-toggle matSuffix [for]="ep"></mat-datepicker-toggle>
      <mat-datepicker #ep></mat-datepicker>
    </mat-form-field>

    <!-- <div class="actions">
      <button mat-raised-button color="primary" (click)="fetchEngagement()">Refresh</button>
      <button mat-stroked-button color="accent" (click)="downloadCSV()">Export CSV</button>
    </div> -->
      <div class="filter-actions" style="display: flex; gap: 8px;">
      <button mat-raised-button color="primary" (click)="fetchEngagement()">
        Refresh
      </button>
      <button mat-stroked-button color="accent" (click)="downloadCSV()" >
        <mat-icon>download</mat-icon> Export CSV
      </button>
    </div>
  </div>

  <div class="chart-container" style="height: 400px; margin-top: 2rem;">
    <canvas baseChart
      [data]="doughnutChartData"
      [options]="doughnutChartOptions"
      [type]="'doughnut'"
      (chartClick)="onChartClick($event)">
    </canvas>
    <p style="text-align: center; color: #64748b; font-size: 0.9rem;">
      Click a segment to see specific conversation IDs.
    </p>
  </div>
</div>